import React, { useEffect, useState, useCallback } from 'react';
import { Table, message, Input } from 'antd';
import axios from 'axios';
import { API_BASE_URL } from '../config';

const PaginatedResultsTable = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 });
    const [sorter, setSorter] = useState({});
    const [collectionId, setCollectionId] = useState(null);

    const fetchData = useCallback((page, pageSize, sorter) => {
        setLoading(true);
        axios.get(`${API_BASE_URL}/api/ResultForBrowser/with-results`, {
            params: {
                page,
                pageSize,
                orderBy: sorter.field || 'Id',
                sortDirection: sorter.order === 'descend' ? 'desc' : 'asc',
                collectionId
            },
            headers: {
                'Accept': 'text/plain',
                'Authorization': 'Bearer qwecqw3cqwceqrcvfqerv',
            },
        })
            .then(({ data }) => {
                setData(data.users);
                setPagination(prev => ({ ...prev, total: data.totalCount }));
            })
            .catch(error => {
                message.error('Failed to load data');
                console.error(error);
            })
            .finally(() => setLoading(false));
    }, [collectionId]);

    useEffect(() => {
        fetchData(pagination.current, pagination.pageSize, sorter);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.current, pagination.pageSize, sorter, fetchData]);

    const handleTableChange = (pagination, _, sorter) => {
        setPagination(prev => ({ ...prev, current: pagination.current }));
        setSorter(sorter);
    };

    const columns = [
        {
            title: 'First Name',
            dataIndex: 'firstName',
            key: 'firstName',
            sorter: true,
        },
        {
            title: 'Scores',
            dataIndex: 'results',
            key: 'score',
            render: results => results.map(r => r.score).join(', ') || '-',
            sorter: true,
        },
    ];

    return (
        <>
            <Input
                placeholder="Filter by Collection ID"
                type="number"
                style={{ marginBottom: 16, width: 200 }}
                onChange={e => setCollectionId(e.target.value ? parseInt(e.target.value, 10) : null)}
            />
            <Table
                columns={columns}
                dataSource={data}
                rowKey="id"
                loading={loading}
                pagination={pagination}
                onChange={handleTableChange}
            />
        </>
    );
};

export default PaginatedResultsTable;
